import { get, omit } from 'lodash';
import moment from 'moment-timezone';

import { DATE_DISPLAY_FORMATS } from '@commons/DatePickers/constants';

/**
 * Check if the store has production time slots
 * If the store has the default production time slot, ie one PTS with no name, we consider it as no production time slots
 *
 * @param {Array} productionTimeSlots - The production time slots
 * @returns {boolean} - True if the production time slots are valid, false otherwise
 */
const hasProductionTimeSlots = (productionTimeSlots) => {
  if (
    !productionTimeSlots.length ||
    (productionTimeSlots.length === 1 && productionTimeSlots[0].name == null)
  ) {
    return false;
  }

  return productionTimeSlots.length > 0;
};

const getFormattedDataWithTimeSlots = (
  productRowsByProductId,
  datasWithTimeSlots,
  selectedDate,
  isProduct,
) => {
  const formattedDataWithTimeSlots = Object.values(datasWithTimeSlots).map((dataWithTimeSlots) => {
    const { id, dataByTimeSlotIds } = dataWithTimeSlots;

    const hasAdminPF =
      productRowsByProductId[id]?.adminProductForecastDates.includes(
        moment(selectedDate).format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY),
      ) || false;

    let totalToProduce = 0;

    const formattedDataByTimeSlotIds = Object.entries(dataByTimeSlotIds).reduce(
      (acc, [ptsId, ptsValue]) => {
        acc[ptsId] = get(ptsValue, isProduct ? 'forecast' : 'toProduce', null);
        totalToProduce += acc[ptsId] || 0;
        return acc;
      },
      {},
    );

    if (!isProduct) {
      return {
        ...omit(dataWithTimeSlots, 'dataByTimeSlotIds'),
        ...formattedDataByTimeSlotIds,
        selectedDate: moment(selectedDate).format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY),
        hasAdminPF,
        total: totalToProduce,
        isViewDayMode: true,
      };
    }

    // Check if the current product has dynamic forecast
    const { hasDynamicForecast } = datasWithTimeSlots[id];

    return {
      ...omit(dataWithTimeSlots, 'dataByTimeSlotIds'),
      ...formattedDataByTimeSlotIds,
      selectedDate: moment(selectedDate).format(DATE_DISPLAY_FORMATS.DASHED_YEAR_MONTH_DAY),
      hasAdminPF,
      total: totalToProduce,
      hasDynamicForecast,
      isViewDayMode: true,
    };
  });

  return formattedDataWithTimeSlots;
};

export default {
  hasProductionTimeSlots,
  getFormattedDataWithTimeSlots,
};
